import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import { AboutPage } from '../pages/about/about';
import { ContactPage } from '../pages/contact/contact';
import { SettingsPage } from '../pages/settings/settings';
import { TabsPage } from '../pages/tabs/tabs';
import { CreatePatientPage} from '../pages/create-patient/create-patient';
import { ReportsPage } from '../pages/reports/reports'

import { LoginPage } from '../pages/login/login'
import { SignupPage } from '../pages/signup/signup'


import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { AuthService } from '../providers/auth-service';
import { Settings } from '../settings/base'
import {HospitalService} from "../providers/hospital-service";
import {PaymentMethodService} from "../providers/payment-service";
import {PatientService} from "../providers/patient-service";
import {PatientPage} from "../pages/patient/patient";
import {PatientsPage} from "../pages/patients/patients";
import {VisitService} from "../providers/visit.service";
import {VisitServiceService} from "../providers/visit-service-service";
import {VisitPage} from "../pages/visit/visit";

@NgModule({
  declarations: [
    MyApp,
    AboutPage,
    ContactPage,
    SettingsPage,
    TabsPage,
    VisitPage,
    PatientsPage,
    LoginPage,
    SignupPage,
    PatientPage,
    CreatePatientPage,
    ReportsPage,
  ],
  imports: [
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    AboutPage,
    ContactPage,
    SettingsPage,
    TabsPage,
    PatientsPage,
    LoginPage,
    SignupPage,
    PatientPage,
    CreatePatientPage,
    ReportsPage,
    VisitPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    AuthService,
    HospitalService,
    PaymentMethodService,
    PatientService,
    VisitService,
    VisitServiceService,
    Settings,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts